module.exports = __webpack_public_path__ + "static/img/kurobanekinokobae_ka.b4c53b0.jpg";